import { useQuery } from 'react-query';
import { queryKey } from 'constants/queryKey';
import { ApiClientError } from 'api/client';
import Logger from 'utils/logger';
import { InstagramAudioApi } from '../api/instagramAudio';
import type { InstagramAudioTrack } from '../types';

type Params = {
  pageId?: number;
  audioId?: string | null;
  enabled?: boolean;
};

/**
 * Never cached beyond the session — Instagram expires `download_url` after
 * about 1.5 days, so the only safe copy is one fetched just now.
 */
export function useInstagramAudioTrackQuery({
  pageId,
  audioId,
  enabled = true,
}: Params) {
  return useQuery<InstagramAudioTrack, ApiClientError>(
    queryKey.instagramAudioTrack({
      pageId: pageId ?? 0,
      audioId: audioId ?? '',
    }),
    () =>
      InstagramAudioApi.detail({
        pageId: pageId ?? 0,
        audioId: audioId ?? '',
      }),
    {
      enabled: enabled && !!pageId && !!audioId,
      staleTime: 0,
      cacheTime: 5 * 60 * 1000,
      onError: (apiError) => Logger.error(apiError),
    },
  );
}
